import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "list-group mb-4" }
const _hoisted_4 = { class: "ms-2 me-auto" }
const _hoisted_5 = ["onClick"]

import { Uuid } from "@/types/api";
import { inject, Ref, ref } from "vue";
import { uuid } from "@/helpers/tools";
import FormKitSubmitButtonContent from "@/components/app/FormKit/FormKitSubmitButtonContent.vue";
import AppIcon from "@/components/app/AppIcon.vue";
import { notifyInjectionKey } from "@/keys";
import AppComponentHeader from "@/components/app/AppComponentHeader.vue";

interface TodoListItem {
  id: Uuid,
  text: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TheTodoList',
  setup(__props) {

const notify = inject(notifyInjectionKey)

class TodoList {
  private readonly LS_KEY = 'not-todo-items'

  constructor (private readonly container: Ref<TodoListItem[]>) {
    const rawValue = localStorage.getItem(this.LS_KEY)

    if (!rawValue) return

    JSON.parse(rawValue).forEach((item: TodoListItem): void => {
      this.container.value.push(item)
    })
  }

  public addItem (item: TodoListItem): void {
    this.container.value.push(item)

    this.flush()

    notify?.({ text: 'Item added', })
  }

  public removeItem (id: Uuid): void {
    this.container.value = this.container.value.filter((i) => i.id !== id)

    this.flush()

    notify?.({ text: 'Item removed', })
  }

  private flush (): void {
    localStorage.setItem(this.LS_KEY, JSON.stringify(this.container.value))
  }
}

const items = ref<TodoListItem[]>([])

const todoList = new TodoList(items)

const model = ref<{ text: string }>({ text: '' })

function addItem (): void {
  todoList.addItem({ id: uuid(), text: model.value.text })
  model.value.text = ''
}

function removeItem (id: Uuid): void {
  todoList.removeItem(id)
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AppComponentHeader, null, {
        default: _withCtx(() => [
          _createTextVNode("Todo")
        ]),
        _: 1
      }),
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.id,
            class: "list-group-item d-flex justify-content-between align-items-start"
          }, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(item.text), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-success btn-sm",
              onClick: ($event: any) => (removeItem(item.id))
            }, [
              _createVNode(AppIcon, { icon: "check" })
            ], 8, _hoisted_5)
          ]))
        }), 128))
      ])
    ]),
    _createVNode(AppComponentHeader, null, {
      default: _withCtx(() => [
        _createTextVNode("Add new task")
      ]),
      _: 1
    }),
    _createVNode(_component_FormKit, {
      modelValue: model.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
      type: "form",
      actions: false,
      onSubmit: addItem
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FormKit, {
          type: "text",
          name: "text",
          required: "",
          placeholder: "Task",
          "outer-class": "mb-3"
        }),
        _createVNode(_component_FormKit, {
          type: "submit",
          "input-class": "btn btn-primary btn-sm"
        }, {
          default: _withCtx(() => [
            _createVNode(FormKitSubmitButtonContent, null, {
              default: _withCtx(() => [
                _createTextVNode("Add")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})